import React, { PropsWithChildren, useState } from "react";

import TableCell from "@material-ui/core/TableCell";
import HistoryIcon from '@material-ui/icons/History';

import { DialogWithActions, GqlTable } from '..';
import { QUERIES } from "../../../graphql";
import { CommunicationEntry } from "../../../graphql/models";
import IconButton from "@material-ui/core/IconButton";

export interface CommunicationDetailsGqlTableProps extends PropsWithChildren<any> {
  communicationId: string;
}

export function CommunicationDetailsGqlTable(props: CommunicationDetailsGqlTableProps) {
  return (
    <GqlTable
      columns={[
        'Inviata il', 'Appartamento', 'Destinatario', 'Nome comunicazione',
        'Letta il'
      ].map(v => (<TableCell>{v}</TableCell>))}
      query={QUERIES.COMMUNICATION_DETAILS}
      queryResultDataField='communicationDetail'
      queryVariables={{
        id: props.communicationId
      }}
      rows={(row: CommunicationEntry) => (
        <>
          <TableCell>{new Date(row.createdAt).toLocaleDateString()}</TableCell>
          <TableCell>{row.apartment.code}</TableCell>
          <TableCell>{row.user.name}</TableCell>
          <TableCell>{row.communication.name}</TableCell>
          <TableCell>
            {row.readDate && new Date(row.readDate).toLocaleDateString()}
            {!row.readDate && 'Non letta'}
          </TableCell>
        </>
      )}
    />
  )
}

export interface CommunicationDetailsProps extends PropsWithChildren<any> {
  communicationId: string;
}

export function CommunicationDetails(props: CommunicationDetailsProps) {
  const { communicationId } = props;
  const [detailsTableDialogOpened, setDetailsTableDialogOpened] = useState(false);

  return (
    <>
      <IconButton 
        color="primary"
        onClick={() => setDetailsTableDialogOpened(true)}
      >
        <HistoryIcon />
      </IconButton>
      <DialogWithActions
        fullScreen={true}
        open={detailsTableDialogOpened}
        setOpen={setDetailsTableDialogOpened}
        title={'Dettaglio comunicazione'}
      >
        <CommunicationDetailsGqlTable
          communicationId={communicationId}
        />
      </DialogWithActions>
    </>
  )
}